// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::-webkit-scrollbar{width:10px}::-webkit-scrollbar-thumb{background:rgba(55,207,55,.3);border-radius:5px}::-webkit-scrollbar-thumb:hover{background:rgba(55,207,55,.5)}", ""]);
// Exports
module.exports = exports;
